import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  cardAction: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  image: {
    borderRadius: '50%',
    display: 'block',
    margin: (0, 'auto'),
  },
  libraryBG: {
    background: '#4D81FA',
    '&:hover': {
      backgroundColor: '#4D81FA',
    },
  },
  wizardBG: {
    background: '#D44917',
    '&:hover': {
      backgroundColor: '#D44917',
    },
  },
  btnText: {
    color: '#FFFFFF',
  },
}))

export default useStyles
